import React, { useState } from "react";
import shortid from "shortid";
import { set } from "dot-prop-immutable";
import { createTabPane, characterShortId } from "@whalecloud/page-builder-core/utils/elementUtils";
import { Table, Icon } from '@whalecloud/fdx';
import { getLocale } from '@utils/util';

characterShortId(shortid);
const uuid = () => shortid.generate();

const StepsSettingsTable = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { steps = [] } = element.data.formItemSettings;
  const { elements } = element;

  const optionArr = steps.map((item, index) => {
    return {
      ...item,
      key: index
    }
  });

  const [dataSource, setDataSource] = useState(optionArr || []);
  const [editingKey, setEditingKey] = useState('');
  const [addRowState, setAddRowState] = useState(false);
  const columns = [
    {
      title: messages['PAGEBUIDER_SETTINGS_STEP_TITLE'],
      dataIndex: "title",
      width: '25%',
      editable: true,
      editRules: [{ required: true, message: `Please Input title!` }]
    },
    {
      title: messages['PAGEBUIDER_SETTINGS_STEP_DESC'],
      dataIndex: "description",
      width: '30%',
      editable: true,
      editRules: [{ required: true, message: `Please Input description!` }]
    },
    {
      title: messages['PAGEBUIDER_SETTINGS_STEP_STATE'],
      dataIndex: "status",
      width: '20%',
      editable: true,
      editType: "select",
      editOptions: [
        { label: "wait", value: "wait" }, 
        { label: "process", value: "process" },
        { label: "finish", value: "finish" },
        { label: "error", value: "error" }
      ],
    },
    {
      title: messages['PAGEBUIDER_SETTINGS_OPERATION'],
      dataIndex: "edit",
      width: '25%',
      editable: true,
      render: (text, record) => <a onClick={() => { delRow(record.key) }}><Icon type="delete" /></a>,
      editContent: () => <Icon type="edit" />,
      saveContent: () => <Icon type="save" />,
      cancelContent: () => <Icon type="stop" />
    }
  ];
  const delRow = key => {
    const index = dataSource.findIndex(v => v.key === key);
    const newElements = elements.filter((v, i) => i !== index);
    const newData = dataSource.filter(item => item.key !== key);
    setDataSource(newData);
    hanldeEleUpdate(newData, newElements)
  }

  const addRow = () => {
    const id = uuid();
    const data = dataSource.concat({
      key: id,
      text: `Step_${id}`,
    });
    setDataSource(data);
    setEditingKey(id);
    setAddRowState(true);
  };

  const onSaveRowEdit = (record, newData) => {
    setDataSource(newData);
    setEditingKey('');
    hanldeEleUpdate(newData, [...elements]);
  }

  const onCancelRowEdit = () => {
    if (addRowState) {
      dataSource.pop()
      setDataSource([...dataSource]);
      hanldeEleUpdate([...dataSource], [...elements]);
    }
    setAddRowState(false);
  }

  const hanldeEleUpdate = (tabs, children) => {
    let newElement = set(element, 'data.formItemSettings.steps', tabs);
    newElement = set(newElement, 'elements', children);
    updateElement({
      element: newElement,
    });

  }

  const footer = () => <a onClick={addRow}>{messages['PAGEBUIDER_SETTINGS_ADD_NEW_OPTION']}</a>;
  return (
    <div>
      <Table
        columns={columns}
        dataSource={dataSource}
        scroll={{ y: 180 }}
        editRow
        editingKey={editingKey}
        onSaveRowEdit={onSaveRowEdit}
        onCancelRowEdit={onCancelRowEdit}
        footer={footer}
        className="formbuild-setting-table"
      />
    </div>
  );
}

export default StepsSettingsTable;
